export default function SkeletonCard() {
  return (
    <div className="animate-pulse overflow-hidden rounded-2xl border border-mlbb-border bg-mlbb-card">
      <div className="h-40 w-full bg-mlbb-border/60" />
      <div className="space-y-2 p-3">
        <div className="h-4 w-1/3 rounded bg-mlbb-border/60" />
        <div className="h-3 w-1/2 rounded bg-mlbb-border/60" />
        <div className="h-3 w-2/3 rounded bg-mlbb-border/60" />
        <div className="flex gap-2 pt-1">
          <div className="h-5 w-12 rounded-full bg-mlbb-border/60" />
          <div className="h-5 w-12 rounded-full bg-mlbb-border/60" />
        </div>
      </div>
    </div>
  );
}
